/**
 * Returns the value of `top`, given a DOMRect
 * @param {DOMRect} rect
 */
export function rectTop (rect) {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop
  return rect.top + scrollTop
}

/**
 * Returns the value of `bottom`, given a DOMRect
 * @param {DOMRect} rect
 */
export function rectBottom (rect) {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop
  return rect.bottom + scrollTop
}

/**
 * Returns the height of the document
 * @returns {Number} the height in pixels
 */
export function getDocumentHeight () {
  return Math.max(
    document.body.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.clientHeight,
    document.documentElement.scrollHeight,
    document.documentElement.offsetHeight
  )
}

/**
 * Returns the current height of the viewport
 * @returns {Number} the height in pixels
 */
export function getWindowHeight () {
  return (
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.getElementsByTagName('html')[0].clientHeight
  )
}

/**
 * Returns the current width of the viewport
 * @returns {Number} the width in pixels
 */
export function getWindowWidth () {
  return (
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.getElementsByTagName('html')[0].clientWidth
  )
}
